import React from "react";
import Modal from "react-modal";
import AddTabForm from "../forms/AddTabForm";

function AddTabModal(props) {
	return (
		<>
			{/* OPEN TAB MODAL BUTTON */}
			<button
				className="modal-button modal-button-tab"
				onClick={props.openModal}
			>
				<i class="fas fa-plus"></i>
			</button>

			{/* TAB MODAL */}
			<Modal
				isOpen={props.modalIsOpen}
				onRequestClose={props.closeModal}
				className="modal-custom-style"
			>
				{/* CLOSE TAB MODAL BUTTON */}
				<button
					className="modal-button  modal-button-close"
					onClick={props.closeModal}
				>
					<i className="fas fa-times"></i>
				</button>

				{/* ADD TAB FORM COMPONENT */}
				<AddTabForm
					closeModal={props.closeModal}
					fetchFirebase={props.fetchFirebase}
					user={props.user}
				/>
			</Modal>
		</>
	);
}

export default AddTabModal;
